import React from "react";
import { IconSize, IconProps } from "../theme";

const Coin: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="CoinVertical">
        <path
          id="Vector"
          d="M24.8137 7.01125C23.305 4.425 21.24 3 19 3H13C10.76 3 8.695 4.425 7.18625 7.01125C5.77625 9.4275 5 12.625 5 16C5 19.375 5.77625 22.5725 7.18625 24.9888C8.695 27.575 10.76 29 13 29H19C21.24 29 23.305 27.575 24.8137 24.9888C26.2237 22.5725 27 19.375 27 16C27 12.625 26.2237 9.4275 24.8137 7.01125ZM24.9737 15H20.9737C20.8956 12.948 20.487 10.9219 19.7638 9H23.5875C24.3525 10.6725 24.8575 12.75 24.9737 15ZM22.3988 7H18.8075C18.3898 6.2754 17.8862 5.60387 17.3075 5H19C20.25 5 21.425 5.75 22.3988 7ZM19 27H17.3113C17.8899 26.3961 18.3936 25.7246 18.8113 25H22.4025C21.425 26.25 20.25 27 19 27ZM23.5875 23H19.765C20.4883 21.0781 20.8969 19.052 20.975 17H24.975C24.8575 19.25 24.3525 21.3275 23.5875 23Z"
          fill="#071443"
        />
      </g>
    </svg>
  );
};

export default Coin;
